import { createApi } from '@reduxjs/toolkit/query/react';
import { baseQuery } from '@/utils/BaseQuery';

export const baseApi = createApi({
  reducerPath: 'baseApi',
  baseQuery,
  tagTypes: [
    'UserManagement',
    'Boats',
    'Feedback',
    'Harbors',
    'FeaturedHarbors',
    'HarborDeletionRequests',
    'HarborRequests',
    'CMS',
    'RegionManagement',
    'POIs',
    'POI_Categories',
    'FeaturedPOIs',
    'ClubsMembers',
    'MembershipRequests',
    'BerthManagement',
    'Berths',
    'FeaturedBerths',
    'BerthCategories',
    'Bookings',
    'Addons',
    'Promos',
    'BerthGroups',
    'Communities',
    'Posts',
    'CommunityRequests',
    'CommunityInvitations',
    'Users',
    'ReportedPosts',
    'Piers',
    'HealthCheck',
    'ExternalServices',
    'Notifications',
    'OrganizationManagement',
    'Regions',
    'IconImages',
    'Deployments',
    'Deployment',
    'ServiceProviders',
    'ClubResources',
    'Services',
    'HarborServices',
    'ServiceRequests',
    'Advertises',
    'Slots',
    'PoiRequests',
    'EmailTemplates',
    'EmailLayout',
    'NotificationTemplates',
    'Events',
    'ServiceProviderBookings',
    'ServiceProviderBerths',
    'ServiceProviderFeaturedBerths',
    'ServiceProviderBerthGroups',
    'ServiceProviderAddons',
    'DiscountReports',
    'HistoricalTrends',
    'RevenueReports',
    'ChurnReports',
    'Transactions',
    'SubscriptionTransactions',
    'Settlements',
    'ProductVatConfigs',
    'PenaltyConfigs',
    'PspFeeConfigs',
    'CommissionPolicies',
    'EntitlementGrants',
    'ThemeRoutes',
    'NotificationPreferences',
    'Articles',
    'Testimonials',
    'DMOInvitations',
    'DMORegistered',
    'HelpdeskFAQ',
    'KYC',
    'PlatformSettings',
    'AccountingExports',
    'DMOStaffs',
    'ListValues',
    'HarborOperatorDashboard',
    'LegalCompliance',
    'GuestVisibility',
    'GuestBookingGovernance',
    'ActivityLogs',
  ],
  endpoints: () => ({}),
});

export default baseApi;
